export class SuggestionItem {
  imageAssetPath: string;
  name: string;

  constructor(imageAssetPath: string, name: string) {
    this.imageAssetPath = imageAssetPath;
    this.name = name;
  }
}
